import { onScopeDispose, ref } from "vue";

/**
 * Tickende "jetzt"-Zeit. Ohne sie wuerden relative Angaben ("vor 12 s")
 * zwischen zwei Server-Updates stehen bleiben.
 */
export function useNow(intervalMs = 1000) {
  const now = ref(Date.now());
  const timer = window.setInterval(() => (now.value = Date.now()), intervalMs);
  onScopeDispose(() => window.clearInterval(timer));
  return now;
}
